function BrowserNotSupportedError(props: { browserName: string }) {
    return (
        <div className="flex flex-col h-full items-center justify-center">
            <div className="px-8 md:max-w-[600px]">
                <div className="text-xl font-semibold pb-6">Browser not supported</div>
                <div className="text-sm pb-2">
                    It looks like you're using a browser ('{props.browserName}') that's incompatible with Muse. For the
                    best experience, please use Google Chrome to join a browser session.
                </div>
            </div>
        </div>
    )
}

export default BrowserNotSupportedError
